import { render, staticRenderFns } from "./MdPatientAllergies.vue?vue&type=template&id=76d6e936&"
import script from "./MdPatientAllergies.vue?vue&type=script&lang=js&"
export * from "./MdPatientAllergies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports